import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
} from "@mui/material";
import { motion } from "framer-motion";
import HeaderUK from "../Images/Offices/iraqAndKurdstan (1).jpg";
import erbil from "../Images/Offices/ErbilImage.jpg";
import Icon from "../Offices/MapOffices/Image/marker-icon.png";
import suleman from "../Images/Offices/sulamany.jpg";
import karkuk from "../Images/Offices/ranya.jpg";
import "../Styles/UKoffice.css";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import MapIraq from "./MapOffices/MapIraq";
import ContactChat from "../Hellper/ContactChat";

const IraqOffice = () => {
  const fadeInVariant = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 1 },
  };
  const listItemVariant = {
    initial: { opacity: 0, x: -50 },
    whileInView: { opacity: 1, x: 0 },
    transition: { duration: 0.5, delay: 0.2 },
  };
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "auto",
        textAlign: "center",
        marginTop: "60px",
      }}
    >
      <header className="new-page-header">
        <img src={HeaderUK} alt="Header" className="new-page-image" />
      </header>

      {/* Offices Grid */}
      <Grid
        container
        spacing={4} // Consistent spacing between items
        sx={{
          mt: 4, // Margin top for the Grid container
          marginBottom: 4, // Margin bottom for the Grid container
          padding: "0 16px", // Padding to prevent overflow
          justifyContent: "center", // Center the grid items
        }}
      >
        {/* Erbil Office */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Card
            sx={{
              maxWidth: "100%", // Make the card responsive
              boxShadow: 4,
              height: "100%", // Ensure all cards have the same height
              display: "flex",
              flexDirection: "column",
              marginBottom: 2, // Add margin bottom to the card
            }}
          >
            <motion.div {...listItemVariant}>
              <CardMedia
                component="img"
                alt="Erbil"
                height="200"
                image={erbil}
                sx={{
                  objectFit: "cover",
                  objectPosition: "center",
                  borderRadius: "8px",
                }}
              />
            </motion.div>
            <motion.div {...fadeInVariant}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                  ئۆفیسی سەرەکی کوردستان
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    mb: 1,
                    direction: "rtl",
                    textAlign: "right",
                  }}
                >
                  ناونیشان:هەولێر، فەرمانبەران، خەدەمی 120 مەتری، جوتسایدی
                  مارکێت سۆفار 2
                  <a
                    href="https://www.google.com/maps?q=36.1545556,44.0608333&entry=gps&lucs=,94224825,94227247,94227248,94231188,47071704,47069508,94218641,94203019,47084304,94208458,94208447&g_ep=CAISEjI0LjQ5LjMuNzAyODc2MTUxMBgAINeCAypjLDk0MjI0ODI1LDk0MjI3MjQ3LDk0MjI3MjQ4LDk0MjMxMTg4LDQ3MDcxNzA0LDQ3MDY5NTA4LDk0MjE4NjQxLDk0MjAzMDE5LDQ3MDg0MzA0LDk0MjA4NDU4LDk0MjA4NDQ3QgJHQg%3D%3D&g_st=com.google.maps.preview.copy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={Icon}
                      width={15}
                      height={15}
                      alt="Location Icon"
                    />
                  </a>{" "}
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Email: info@uktomars.co.uk
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  تەلەفون: 0772 807 7272
                </Typography>
              </CardContent>
            </motion.div>
          </Card>
        </Grid>

        {/* Sulemaniyah Office */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Card
            sx={{
              maxWidth: "100%",
              boxShadow: 4,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              marginBottom: 2, // Add margin bottom to the card
            }}
          >
            <motion.div {...listItemVariant}>
              <CardMedia
                component="img"
                alt="Sulemaniyah"
                height="200"
                image={suleman}
                sx={{
                  objectFit: "cover",
                  objectPosition: "center",
                  borderRadius: "8px",
                }}
              />
            </motion.div>
            <motion.div {...fadeInVariant}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                  سلێمانی
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    mb: 1,
                    direction: "rtl",
                    textAlign: "right",
                  }}
                >
                  ناونیشان:گەرەکی بەختیاری، بەرامبەر شاری جوان، بەرامبەر ناوەندی
                  رۆشنبیری دکتۆر عیزەدین{" "}
                  <a
                    href="https://www.google.com/maps?q=HCC3+3XR+Swiss+Market+Suli,+Sulaymaniyah,+Sulaymaniyah+Governorate,+Iraq&ftid=0x40002f51a7909b3d:0x5e6c37b188b3e062&entry=gps&lucs=,94224825,94227247,94227248,94231188,47071704,47069508,94218641,94203019,47084304,94208458,94208447&g_ep=CAISEjI0LjQ5LjMuNzAyODc2MTUxMBgAINeCAypjLDk0MjI0ODI1LDk0MjI3MjQ3LDk0MjI3MjQ4LDk0MjMxMTg4LDQ3MDcxNzA0LDQ3MDY5NTA4LDk0MjE4NjQxLDk0MjAzMDE5LDQ3MDg0MzA0LDk0MjA4NDU4LDk0MjA4NDQ3QgJHQg%3D%3D&g_st=com.google.maps.preview.copy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={Icon}
                      width={15}
                      height={15}
                      alt="Location Icon"
                    />
                  </a>
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Email: info@uktomars.co.uk
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  تەلەفون: 0772 807 7272
                </Typography>
              </CardContent>
            </motion.div>
          </Card>
        </Grid>

        {/* Kirkuk Office */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Card
            sx={{
              maxWidth: "100%",
              boxShadow: 4,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              marginBottom: 2, // Add margin bottom to the card
            }}
          >
            <motion.div {...listItemVariant}>
              <CardMedia
                component="img"
                alt="Kirkuk"
                height="200"
                image={karkuk}
                sx={{
                  objectFit: "cover",
                  objectPosition: "center",
                  borderRadius: "8px",
                }}
              />
            </motion.div>
            <motion.div {...fadeInVariant}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                  رانیە
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    mb: 1,
                    direction: "rtl",
                    textAlign: "right",
                  }}
                >
                  ناونیشان: گەرەکی ئازادی، بەرامبەر باخچەی ساوایانی شنە(مەکتەبی
                  رەنجدەرانی کۆن)
                  <a
                    href="https://www.google.com/maps?q=Rashamerg,+Ranya,+Sulaymaniyah+Governorate,+Iraq&ftid=0x40014ecfea497cb7:0x518f9778c77a49a7&entry=gps&lucs=,94224825,94227247,94227248,94231188,47071704,47069508,94218641,94203019,47084304,94208458,94208447&g_ep=CAISEjI0LjQ5LjMuNzAyODc2MTUxMBgAINeCAypjLDk0MjI0ODI1LDk0MjI3MjQ3LDk0MjI3MjQ4LDk0MjMxMTg4LDQ3MDcxNzA0LDQ3MDY5NTA4LDk0MjE4NjQxLDk0MjAzMDE5LDQ3MDg0MzA0LDk0MjA4NDU4LDk0MjA4NDQ3QgJHQg%3D%3D&g_st=com.google.maps.preview.copy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={Icon}
                      width={15}
                      height={15}
                      alt="Location Icon"
                    />
                  </a>
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Email: info@uktomars.co.uk
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  تەلەفۆن:0750 1969114
                </Typography>
              </CardContent>
            </motion.div>
          </Card>
        </Grid>
      </Grid>

      {/* Map Section */}
      <Box sx={{ marginTop: 4, marginBottom: 4 }}>
        <MapIraq />
      </Box>

      {/* Contact Chat Section */}
      <Box sx={{ marginTop: 4, marginBottom: 4 }}>
        <ContactChat />
      </Box>
    </Box>
  );
};

export default IraqOffice;
